module.exports = __webpack_public_path__ + "static/img/4.ceb9244.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/9/sp/4.png
// module id = Rnuj
// module chunks = 0